"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _UsernameAuthForm = require("./UsernameAuthForm");
Object.keys(_UsernameAuthForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UsernameAuthForm[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _UsernameAuthForm[key];
    }
  });
});